// extracted by mini-css-extract-plugin
export default {"selectContainer":"SelectBodyPart_selectContainer__Ox7Rm","menu":"SelectBodyPart_menu__8R1L8"};